import React, { ReactElement } from 'react';

import { Video as VideoType } from '@bighealth/types/src/scene-components/client';

import { Video } from 'components/Media';
import { WithBackupFormikContext } from 'components/WithBackupFormikContext';
import { getIsAssetContinuous } from 'lib/player/assetContinuity';
import { SceneComponentWithParent } from 'lib/player/tree-utils';

const SceneSetVideoWithoutFallbackFormikContext = (
  props: VideoType
): ReactElement => {
  const { sourceProps, fromSeconds, toSeconds, delaySeconds, ...rest } = props;
  const src = sourceProps?.storage_url || '';
  const isContinuous = getIsAssetContinuous(
    (props as unknown) as SceneComponentWithParent
  );
  return (
    <Video
      {...rest}
      src={src}
      from={fromSeconds || 0}
      to={toSeconds || sourceProps.duration || 0}
      delay={delaySeconds || 0}
      isContinuous={isContinuous}
      captionSrc={sourceProps?.captions_storage_url}
      captions={sourceProps?.captions_data}
    />
  );
};

const SceneSetVideo = (props: VideoType): ReactElement => {
  return WithBackupFormikContext(
    props,
    SceneSetVideoWithoutFallbackFormikContext
  );
};

export default SceneSetVideo;
